// extracted by mini-css-extract-plugin
module.exports = {"DescriptionCard":"DescriptionCard___cHURu"};